import { combineReducers } from 'redux';
import { reducer as expReducer, EXPERIMENTS_NAMESPACE } from '@soundtrackyourbrand/experiments.js'

export default combineReducers({ [EXPERIMENTS_NAMESPACE]: expReducer });